import { ReportCardEnum } from "@repo/core/types/reports";
import { ReportCard } from ".";
import { ReportCardProps } from "./types";

export const getReportCardByReportType = (
  reportType: ReportCardEnum,
  cardProps: Omit<ReportCardProps, "variant">
) => {
  switch (reportType) {
    case ReportCardEnum.REASON_DENIAL:
      return <ReportCard.NegatedReason {...cardProps} />;
    case ReportCardEnum.ANALYSED_PROPOSALS:
      return <ReportCard.AnalysedProposals {...cardProps} />;
    case ReportCardEnum.MONTHLY_TRANSACTIONS:
      return <ReportCard.MonthlyTransactions {...cardProps} />;
  }
};
